import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <RankingSection />
        <AppSection />
        <UpdatesSection />
        <CarouselSection />
        <CommentsSection />
        <FaqSection />
        <CardsSection />
        <MediaSection />
        <AboutSection />
        <IndexSection />
        <FeaturesSection />
        <ContactSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}